import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { BlockElement } from '~/components/PluginsEditor/types';
import ELEMENTS from '~/components/PluginsEditor/components/elements/elementsEnum';
import serialize from './serialize';

export type Props = RenderElementProps & {
  dataTestId?: string;
  element: BlockElement;
};

const Div: React.FC<Props> = ({
  dataTestId,
  children,
  attributes,
  element,
}) => (
  <Container data-testid={dataTestId} {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.div<{}>``;

export default {
  nodeName: 'DIV',
  renderComponent: props => <Div {...props} />,
  deserialize: () => ({
    type: ELEMENTS.DIV,
  }),
  serialize,
};
